import React, { Component } from 'react'
import { restUrl } from 'config'
import request from 'superagent'
import BackButton from 'components/backButton'
import { Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import moment from 'moment'
import ReactMarkdown from 'react-markdown'

class Thread extends Component {

  constructor(props) {
    super(props)
    this.state = {
      thread: null,
      threadPosts: [],
      showModal: false
    }
    this.getThreadDetails = this.getThreadDetails.bind(this);
  }

  close() {
    this.setState({showModal: false})
  }

  open() {
    this.setState({showModal: true})
  }

  onSubmit(e) {
    e.preventDefault()
    const text = this.refs.text.value
    if (!text)
      return
    request
      .post(restUrl + 'forum/post')
      .send({
        text,
        thread: this.state.thread._id,
        author: {
          name: this.props.auth.user.forumName,
          _id: this.props.auth.user.id
        }
      }).end((err, res) => {
        if (!err) {
          const { threadPosts } = this.state
          threadPosts.push(res.body)
          this.setState({
            threadPosts,
            showModal: false
          })
        }
      })
  }

  componentDidMount() {
    this.getThreadDetails()
  }

  getThreadDetails() {
    let threadId 
    try {
      threadId = this.props.location.state.threadId
      request
      .get(restUrl+'forum/thread/'+threadId)
      .end((err, res) =>{
        this.setState({
          threadPosts: res.body.posts,
          thread: res.body
        })
      })
    }
    catch(err) {
      let forumName = this.props.location.pathname.split('forum/')[1].split('/')[0]
      let threadName = this.props.location.pathname.split('forum')[1].split('/')[2]
      request
      .get(restUrl + 'forum')
      .end((err, res) => res)
      .then(response => {
        response.body.forEach(forum => {
          if(forum.title.split(' ').join('')[0].toLowerCase() === forumName.toLowerCase()) {
            request
              .get(restUrl+'forum/'+forum._id)
              .end((err, res) => {
                if(!err) {
                   res.body.threads.forEach((thread)=> {
                     if(thread.title.split(' ').join('').split('?')[0].toLowerCase() === threadName.toLowerCase()) {
                        request
                        .get(restUrl+'forum/thread/'+thread._id)
                        .end((err, res)=> {
                          this.setState({
                            threadPosts:res.body.posts,
                            thread: res.body
                          })
                        })
                     }
                   })
                }
            })
          }
        })
      })
    }
  }  

  render() {
    if (!this.state.thread) {
      return <div> loading </div>
    }
    return (
      <div className="container-fluid">
        <BackButton />
        <div className='panel'>
          <header className='panel-heading'>
            <span>{ this.state.thread.title }</span>
            <span className='pull-right'>{ 'By ' + this.state.thread.author.name}</span>
          </header>
          <div className='panel-body'>
            <div className='list-group'>
              <div className='list-group-item'>
                <ReactMarkdown source={ this.state.thread.text } />
              </div>
              {
                this.state.threadPosts.map(post => (
                  <div className='list-group-item' key={post._id}>
                    <ReactMarkdown source={post.text} />
                    <span className='text-muted'>{ 'By ' + post.author.name + ', ' + moment(post.createdAt).fromNow() }</span>
                  </div>)
                )
              }
            </div>
            <button type='button' className='btn btn-default' onClick={this.open.bind(this)}>Submit a reply</button>
          </div>
        </div>
        <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>Create a new post</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form className='form-horizontal'>
              <div className='form-group'>
                <label className='col-xs-2'>Message</label>
                <div className='col-xs-10'>
                  <textarea className='form-control' rows='4' ref='text' />
                </div>
              </div>
              <div className='form-group'>
                <div className='col-xs-10 col-xs-offset-2'>
                  <button type='submit' className='btn-success btn' onClick={this.onSubmit.bind(this)}>Submit</button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default connect(state => ({auth: state.auth}))(Thread)




/** WEBPACK FOOTER **
 ** ./src/components/forum/Thread.js
 **/